import ApiServer from "../ApiServer.ts";
import * as FwDatas from "../FwDatas.ts";
import {isSameDay} from "../lib/DateUtils.ts";
import * as i18n from "../i18n.ts";
import * as decoders from "../server/decoders_connected.ts";

var threadByIds: Record<string, any> = {},threadIdByParticipantKey: Record<string, string> = {};
Object.assign(ApiServer.types.IIMThread.prototype,{
  participantLine :function(): string {
    var
      i: number,
      builder = "";

    for(i=1;i<this.participants.length;i++){
      builder += this.participants[i].accountFirstname+', ';
    }
    builder= builder.substring(0,builder.length-2);
    return builder;
  },
  participantKey:function(): string {
    return this.participants.slice(1).map(function(o: any){return o.accountId;}).sort().join(',');
  },
  participantForImgLength :function(): number {
    return Math.min(4,this.participants.length-1);
  },
  participantForImg :function(): any[] {
    var extraCount: number,toDisplay = this.participants.filter(function(p: any,idx: number){
      return !p.isLogguedAccount;
    });
    if(toDisplay.length>4){
      extraCount = toDisplay.length-3;
      toDisplay.splice(3,extraCount,{avatar:"<span class='"+(extraCount>9?'fw-participant-extra-small':'')+"'>+"+extraCount+"</span>"});
    }
    return toDisplay;
  },
  onDecode(): void {
    threadIdByParticipantKey[this.participantKey()] = this.metaId;
  }
});
Object.assign(ApiServer.types.IIMParticipant.prototype,{
  avatar:function(): string {
    return "<img src='"+this.thumb()+"' title='"+this.accountFirstname+"'>";
  }
});
Object.assign(ApiServer.types.IIMMessage.prototype,{
  onDecode(): void {
    decoders.mapMedia(this);
    decoders.decodeGiphy(this);
    var thread = threadByIds[this.threadId],i: number,len: number;
    //a thread just created by the send message will not be in cache
    if(!thread){
      return;
    }
    for(i=0,len=thread.participants.length;i<len;i++){
      var p = thread.participants[i];
      if(p.accountId===this.fromId){
        this.participant = p;
      }
      if(p.isLogguedAccount){
        this.meAsParticipant = p;
      }
    }
    this.isUnread = this.creationDate>this.meAsParticipant.lastReadMessageDate;
    this.accountFirstname = this.participant.accountFirstname;
    this.preview = this.text.match(/https?:\/\/[^\s]*gif/g)?(this.isMe()?i18n.get("im.gifsent"):i18n.getMustache("im.gifreceived",this)):this.text;
  },
  thread:function(): any {
    return threadByIds[this.threadId];
  },
  author:function(): string {
    return FwDatas.getProfile(this.fromId).firstName;
  },
  isMe:function(): boolean {
    return this.participant.isLogguedAccount;
  }
});
function prepareMessageList(list: any[]): void {
  list.sort(function(a,b){
    return a.creationDate-b.creationDate;
  });
  var prevMessage = list[0],i: number;
  for(i=1;i<list.length;i++){
    var message = list[i];
    if(message.fromId===prevMessage.fromId){
      message.hideAuthor = true;
      if(message.creationDate-prevMessage.creationDate<60000){
        prevMessage.hideTime = true;
      }
    }else{
      message.hideAuthor = false;
    }
    if(isSameDay(message.creationDate,prevMessage.creationDate)){
      message.hideDate = true;
    }

    prevMessage = message;
  }
}

var cachedThread: any;
function isEquals(threadList1: any[], threadList2: any[]): boolean {
  if(threadList1.length===threadList2.length){
    for(var i=0;i<threadList2.length;i++){
      if(threadList1[i].messageListModifDate - threadList2[i].messageListModifDate !==0){
        return false;
      }
    }
    return true;
  }
  return false;
}

export async function withallthread(isInit?: boolean): Promise<any[]> {
  //if isInit and something in cache we do it while checking if there is a change
  if(isInit && cachedThread!==undefined){
    return cachedThread;
  }
  var threads = await ApiServer.customimthreadlist()
  //sort thread
  threads.sort(function(a: any,b: any){
    return b.sortingDate-a.sortingDate;
  });

  if(cachedThread!==undefined && isEquals(threads,cachedThread)){
    if(isInit){
      return cachedThread;
    }else{
      threads = cachedThread;
    }
  }else{
    cachedThread = threads;
  }

  //store them by id
  threads.forEach(function(obj: any){
    var oldThread = threadByIds[obj.metaId];
    threadByIds[obj.metaId] = obj;
    if(oldThread){
      if(oldThread.messageListModifDate==obj.messageListModifDate){
        //keep messages if unchanged
        obj.messages = oldThread.messages;
        obj.lastmessage = oldThread.lastmessage;
      }else{
        //console.log("thread updated")
      }
    }
  });

  var idsToUpdate = threads.filter((thread: any)=>thread.messages===undefined).map(function(o: any){return o.metaId;});
  if(idsToUpdate.length){
    //load last message of each
    var list = await ApiServer.immessagelistgrp(idsToUpdate,1)
    for(var i=0;i<list.length;i++){
      var thread = threadByIds[idsToUpdate[i]];
      thread.messages=list[i];
      thread.lastmessage = thread.messages.datas[0];
    }
  }
  return threads;
}
export async function withfullthread(threadId: string, refresh?: boolean): Promise<any> {
  var
    thread = threadByIds[threadId],
    messages = thread.messages;

  if(refresh || (messages.nextPageId!=null &&  messages.datas.length<=1)){
    var messages = await ApiServer.immessagelist2(threadId, new ApiServer.types.SimplePaginationRequest({count:50}));
    thread.lastmessage = messages.datas[0];
    thread.messages = messages;
    prepareMessageList(messages.datas);
  }
  return thread;

}
export async function withOlderMessages(threadId: string, nextPageId: string): Promise<any> {
  const messages = await ApiServer.immessagelist2(threadId,new ApiServer.types.SimplePaginationRequest({count:50,pageId:nextPageId}))
  prepareMessageList(messages.datas);
  //give a fake thread with only asked messages
  return {messages};

}
export function withparticipant(participantKey: string | string[]): string | undefined {
  if(typeof participantKey === 'object'){
    participantKey = participantKey.sort().join(',');
  }
  return (threadIdByParticipantKey[participantKey]);
}
